import React, { useState } from 'react';
import Header from '../Common_Files/Header';
import Footer from '../Common_Files/Footer';
import config from '../Common_Files/Config';
import SupplierSearch from '../Purchase/SupplierSearch';
import ViewSupplier from '../Master/ViewSupplier';
import SupplierCreditAllocation from './SupplierCreditAllocation';
import { DateRangePicker } from 'rsuite';
import { format } from 'date-fns';

const parseFilterDate = (value) => {
    if (!value) return null;
    const parts = String(value).split('/');
    if (parts.length !== 3) return null;
    const month = parseInt(parts[0], 10);
    const day = parseInt(parts[1], 10);
    const year = parseInt(parts[2], 10);
    if (!month || !day || !year) return null;
    const date = new Date(year, month - 1, day);
    return Number.isNaN(date.getTime()) ? null : date;
};

const SupplierLedger = () => {
    const accessToken = localStorage.getItem('accessToken');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [reportrange, setReportrange] = useState('');
    const [searchSupplier, setSearchSupplier] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [supplierInfo, setSupplierInfo] = useState({ company: '', accound_no: '', phone: '' });
    const [debtProfile, setDebtProfile] = useState({
        zeroto30Due: '0.00',
        moreThan30DaysDue: '0.00',
        moreThan60DaysDue: '0.00',
        moreThan90DaysDue: '0.00',
        current_outstanding: '0.00',
        total_due1: '0.00',
    });
    const [unallocated, setUnallocated] = useState('0.00');
    const [ledgerRows, setLedgerRows] = useState([]);
    const [periodLabel, setPeriodLabel] = useState('');
    const [showAllocation, setShowAllocation] = useState(false);
    const [allocationCreditId, setAllocationCreditId] = useState('');

    const handleDateChange = (dates) => {
        if (dates && dates.length === 2) {
            const [start, end] = dates;
            setFromDate(format(start, 'MM/dd/yyyy'));
            setToDate(format(end, 'MM/dd/yyyy'));
            setReportrange(`${format(start, 'dd/MM/yyyy')} - ${format(end, 'dd/MM/yyyy')}`);
        } else if (!dates) {
            setFromDate('');
            setToDate('');
            setReportrange('');
        }
    };

    const handleSearch = async () => {
        if (!searchSupplier) {
            setMessage('Please select supplier');
            return;
        }
        if (!accessToken) {
            window.location.href = '/login';
            return;
        }
        setLoading(true);
        setMessage('');
        const formData = new FormData();
        formData.append('supplier_id', searchSupplier);
        formData.append('start_date', fromDate);
        formData.append('end_date', toDate);
        formData.append('driver', '0');
        formData.append('sale_rep', '0');
        try {
            const response = await fetch(`${config.api_url}/get_supplier_ladger`, {
                method: 'POST',
                headers: { authorization: `Bearer ${accessToken}` },
                body: formData,
            });
            const json = await response.json();
            if (!json.success || !json.data || !json.data.supplier) {
                setSupplierInfo({ company: '', accound_no: '', phone: '' });
                setLedgerRows([]);
                setDebtProfile({
                    zeroto30Due: '0.00',
                    moreThan30DaysDue: '0.00',
                    moreThan60DaysDue: '0.00',
                    moreThan90DaysDue: '0.00',
                    current_outstanding: '0.00',
                    total_due1: '0.00',
                });
                setUnallocated('0.00');
                setPeriodLabel('');
                setMessage(json.message || 'No transaction available for selected criteria.');
                return;
            }
            const data = json.data;
            setSupplierInfo({
                company: data.supplier?.company || '',
                accound_no: data.supplier?.accound_no || '',
                phone: data.supplier?.phone || '',
            });
            setDebtProfile(data.debtProfile || {});
            setUnallocated(data.allocation_amout?.[0]?.total || '0.00');
            setLedgerRows(Array.isArray(data.supplier_ledger) ? data.supplier_ledger : []);
            setPeriodLabel(
                data.start_date && data.end_date ? `${data.start_date} - ${data.end_date}` : reportrange
            );
            setMessage(
                data.supplier_ledger && data.supplier_ledger.length > 0
                    ? ''
                    : 'No transaction available for selected period.'
            );
        } catch {
            setMessage('Failed to load supplier ledger');
        } finally {
            setLoading(false);
        }
    };

    const openAllocation = (creditLedgerId = '') => {
        if (!searchSupplier) return;
        setAllocationCreditId(creditLedgerId ? String(creditLedgerId) : '');
        setShowAllocation(true);
    };

    const unallocatedNum = parseFloat(String(unallocated).replace(/,/g, '')) || 0;

    return (
        <div>
            <Header />
            <ViewSupplier />
            <div className="breadcrumbs">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12 col-lg-12 col-sm-12">
                            <a href="#"><i className="fa fa-home"></i></a> &gt;{' '}
                            <a href="/Dashboard">Dashboard</a> &gt;{' '}
                            <span className="last-crumb">Supplier Ledger</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`main-container${showAllocation ? ' supplier-ledger-page-dimmed' : ''}`}>
                <div className="container-fluid supplier-ledger-page-content">
                    <div className="show-order-area dashboard account-ledger-page">
                        <div className="account-ledger-toolbar">
                            <div className="dashform">
                                <div className="topsearch-area sales-ledger-filters">
                                    <div className="row g-2 g-lg-3 align-items-end">
                                        <div className="col-12 col-md-6 col-xl-4">
                                            <label className="col-form-label">Supplier</label>
                                            <SupplierSearch
                                                value={searchSupplier}
                                                setSearchSupplier={setSearchSupplier}
                                            />
                                        </div>
                                        <div className="col-12 col-md-6 col-xl-4">
                                            <label className="col-form-label">Date Range</label>
                                            <DateRangePicker
                                                format="dd/MM/yyyy"
                                                editable={false}
                                                cleanable
                                                placeholder="DD/MM/YYYY - DD/MM/YYYY"
                                                style={{ width: '100%' }}
                                                value={[
                                                    parseFilterDate(fromDate),
                                                    parseFilterDate(toDate),
                                                ]}
                                                onChange={handleDateChange}
                                                onClean={() => {
                                                    setFromDate('');
                                                    setToDate('');
                                                    setReportrange('');
                                                }}
                                            />
                                        </div>
                                        <div className="col-12 col-md-6 col-xl-2">
                                            <button
                                                type="button"
                                                className="btn btn-primary w-100"
                                                onClick={handleSearch}
                                                disabled={loading}
                                            >
                                                {loading ? 'Loading...' : 'Search'}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="account-ledger-results">
                        {message ? (
                            <div className="alert alert-warning mt-3" role="alert">
                                {message}
                            </div>
                        ) : null}
                        {supplierInfo.company ? (
                            <div className="mt-3 mb-2">
                                <strong>
                                    {supplierInfo.company}
                                    {supplierInfo.accound_no ? ` (${supplierInfo.accound_no})` : ''}
                                </strong>
                                {supplierInfo.phone ? (
                                    <span className="ms-3">Phone: {supplierInfo.phone}</span>
                                ) : null}
                                {periodLabel ? (
                                    <span className="ms-3">Period: {periodLabel}</span>
                                ) : null}
                            </div>
                        ) : null}
                        {supplierInfo.company ? (
                            <div className="verical-scrl-wrapper common-table account-ledger-summary mb-3">
                                <table className="table table-bordered dataTable">
                                    <thead>
                                        <tr>
                                            <th>Amt. Due</th>
                                            <th>Unallocated</th>
                                            <th>0 To 30 Days</th>
                                            <th>30+ Days</th>
                                            <th>60+ Days</th>
                                            <th>90+ Days</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="text-end">{debtProfile.current_outstanding}</td>
                                            <td className="text-end">
                                                {unallocatedNum > 0 ? (
                                                    <button
                                                        type="button"
                                                        className="btn btn-link p-0 align-baseline"
                                                        onClick={() => openAllocation()}
                                                    >
                                                        {unallocated}
                                                    </button>
                                                ) : (
                                                    unallocated
                                                )}
                                            </td>
                                            <td className="text-end">{debtProfile.zeroto30Due}</td>
                                            <td className="text-end">{debtProfile.moreThan30DaysDue}</td>
                                            <td className="text-end">{debtProfile.moreThan60DaysDue}</td>
                                            <td className="text-end">{debtProfile.moreThan90DaysDue}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        ) : null}
                        <div className="verical-scrl-wrapper common-table account-ledger-table-scroll">
                            <table className="table table-bordered dataTable">
                                <thead>
                                    <tr>
                                        <th>Sr. No.</th>
                                        <th>Date</th>
                                        <th>Bill / Ref No</th>
                                        <th>Type</th>
                                        <th className="text-end">Debit</th>
                                        <th className="text-end">Credit</th>
                                        <th className="text-end">Balance</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {ledgerRows.length === 0 ? (
                                        <tr>
                                            <td colSpan="8" className="text-center">
                                                No transaction available
                                            </td>
                                        </tr>
                                    ) : (
                                        ledgerRows.map((row, index) => {
                                            const typeNorm = String(row.type || '').toLowerCase();
                                            const isPayment = typeNorm === 'payment' || row.is_payment === true;
                                            return (
                                                <tr
                                                    key={row.id || index}
                                                    className={isPayment ? 'account-ledger-payment-row' : ''}
                                                >
                                                    <td>{index + 1}</td>
                                                    <td>{row.date}</td>
                                                    <td>{row.reference_no}</td>
                                                    <td>{row.type}</td>
                                                    <td className="text-end">{row.debit}</td>
                                                    <td className="text-end">{row.credit}</td>
                                                    <td className="text-end">{row.balance}</td>
                                                    <td>{row.status}</td>
                                                </tr>
                                            );
                                        })
                                    )}
                                </tbody>
                            </table>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            {showAllocation && searchSupplier ? (
                <SupplierCreditAllocation
                    supplierId={searchSupplier}
                    supplierName={supplierInfo.company}
                    initialCreditLedgerId={allocationCreditId}
                    onClose={() => setShowAllocation(false)}
                    onSuccess={handleSearch}
                />
            ) : null}
            <Footer />
        </div>
    );
};

export default SupplierLedger;
